<template>
  <div
    class="item"
    :class="{
      'is-opened': isOpened,
    }"
  >
    <div class="title" @click="toggleItem()">
      <h3 :id="uid" v-html="data.title" />
      <button class="toggle" :aria-labelledby="uid">
        <svg class="icon"><use href="#chevron-down" /></svg>
      </button>
    </div>
    <div class="description__wrapper">
      <transition
        name="slidedown"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave"
        @leave="leave"
      >
        <p v-show="isOpened" class="description" v-html="data.description" />
      </transition>
    </div>
  </div>
</template>

<script>
import { useId } from 'vue';

export default {
  setup() {
    return { uid: useId() };
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isOpened: false,
      data: this.item,
    };
  },
  methods: {
    toggleItem() {
      this.isOpened = !this.isOpened;
    },
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave(el) {
      el.style.height = '0';
    },
  },
};
</script>
